import { render, staticRenderFns } from "./FieldInfoTypeC.vue?vue&type=template&id=118a4088&scoped=true&"
import script from "./FieldInfoTypeC.vue?vue&type=script&lang=js&"
export * from "./FieldInfoTypeC.vue?vue&type=script&lang=js&"
import style0 from "./FieldInfoTypeC.vue?vue&type=style&index=0&id=118a4088&prod&scoped=true&lang=scss&"
import style1 from "./FieldInfoTypeC.vue?vue&type=style&index=1&id=118a4088&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118a4088",
  null
  
)

export default component.exports